import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { SiNewtonLoadingService } from '@simpl/newton-ng/loading-spinner';
import { Entry } from 'src/app/data-models/entry';
import { AdditionalDataRestService } from 'src/app/services/additional-data-rest.service';
import { CustomHttpService } from 'src/app/services/custom-http.service';
import { CustomToastService } from 'src/app/services/custom-toast.service';


@Component({
  selector: 'app-libraries-data',
  templateUrl: './libraries-data.component.html',
  styleUrls: ['./libraries-data.component.scss']
})
export class LibrariesDataComponent implements OnInit {
  @Input()
  userRole!: string;

  documentFile!: File;

  libraryForm: FormGroup;

  @Input() contractName!: string;
  @Input() contractId!: number;
  libraryEntries: Array<Entry> = [];

  checkStatusEntry!: string;

  uploadFile(entryId: number, e: Event) {

    this.loadingSpinner.startLoading();

    this.documentFile = (e.target as HTMLInputElement).files!.item(0)!;

    this.additionalDataService.uploadDocumentForEntry(entryId, this.documentFile, this.contractName).then( res => {

      this.loadingSpinner.stopLoading();
      this.toastService.showInfoToast(res);

      this.additionalDataService.getEntries(this.contractId, 'library').then( (res: any) => {
        this.libraryEntries = res;

        this.addStatusFormControls();
      }).catch(errorMessage => {
        console.log(errorMessage);
        this.toastService.showErrorToast(errorMessage);
      });

    }).catch(errorMessage => {
      this.loadingSpinner.stopLoading();

      this.toastService.showErrorToast(errorMessage);
    });

  }

  async downloadFile(fileName: string){

    await this.customHttpService.downloadFile(fileName, 'documents');

  }

  async addEntry(){

    await this.additionalDataService.addEntry(this.contractId, 'library', this.libraryForm.get('entryName')?.value,
    this.libraryForm.get('comment')?.value).then( async (res: any) => {
      this.libraryForm.reset();

      this.libraryEntries = res;
      this.addStatusFormControls();
    }).catch(errorMessage => {
      console.log(errorMessage);
      this.toastService.showErrorToast(errorMessage);
    });
  }


  async updateEntry(entryId: number, entryName: string, entryComment: string){

    this.loadingSpinner.startLoading();

    await this.additionalDataService.updateEntry(this.contractId, 'library', entryId, entryName, entryComment).then( async (res: any) => {
      this.libraryForm.reset();

      this.libraryEntries = res;
      this.addStatusFormControls();

      this.toastService.showInfoToast('Updated entry successfuelly');
    }).catch(errorMessage => {
      console.log(errorMessage);
      this.toastService.showErrorToast(errorMessage);

    }).finally(() => {
      this.loadingSpinner.stopLoading();
    });
  }

  async deleteEntry(entryId: number){

    await this.additionalDataService.deleteEntry(this.contractId, 'library', entryId).then( async (res: any) => {

      this.libraryForm.reset();
      this.libraryEntries = res;

      this.addStatusFormControls();

    }).catch(errorMessage => {
      console.log(errorMessage);
      this.toastService.showErrorToast(errorMessage);
    });
  }

  async updateEntryStatus(entryId: number, status: String){
    await this.additionalDataService.updateEntryStatus(entryId, status).catch(errorMessage => {
      this.toastService.showErrorToast(errorMessage);
    })
  }

  addStatusFormControls(){
    for (let i = 0; i < this.libraryEntries.length ; i++) {

      this.libraryForm.addControl(
        'checkStatusEntry' + i.toString(),
        new FormControl(null, null)
      );

      this.libraryForm.addControl(
        'entryName' + i.toString(),
        new FormControl(null, null)
      );

      this.libraryForm.addControl(
        'comment' + i.toString(),
        new FormControl(null, null)
      );
    }
  }

  constructor(private loadingSpinner: SiNewtonLoadingService, private formBuilder: FormBuilder, private customHttpService: CustomHttpService,
    private additionalDataService: AdditionalDataRestService, private toastService: CustomToastService) {
    this.libraryForm = this.formBuilder.group({
      entryName: [null, Validators.required],
      comment: [null, Validators.required]
    });
  }

  ngOnInit(): void {
    this.loadingSpinner.startLoading();

    this.additionalDataService.getEntries(this.contractId, 'library').then( (res: any) => {
      this.libraryEntries = res;

      this.addStatusFormControls();

      if(this.userRole != 'admin' && this.userRole != 'user'){
        this.libraryForm.disable();
      }
    }).catch(errorMessage => {
      console.log(errorMessage);
      this.toastService.showErrorToast(errorMessage);
    });
    this.loadingSpinner.stopLoading();
  }

}
